import { useParams } from "react-router-dom";
import { Eyebrow } from "@/components/shared";
import { AlertTriangle } from "lucide-react";

const docs = {
  terms: ["Terms of Service", "These Terms govern your use of ZettaKeep's managed offsite Proxmox Backup Server service. By deploying a backup server you agree to acceptable use, subscription billing, and the service levels described in our SLA."],
  privacy: ["Privacy Policy", "We collect account information, billing metadata (via Stripe), and operational metrics required to run and monitor your backup infrastructure. We never possess your client-side encryption keys and never sell your data."],
  aup: ["Acceptable Use Policy", "ZettaKeep may not be used to store unlawful content or to circumvent storage quotas. Backup data belongs to you; abuse of shared infrastructure may result in suspension per our published policy."],
  dpa: ["Data Processing Addendum", "This DPA describes how ZettaKeep processes personal data on your behalf as a processor, including subprocessors, security measures, and data-deletion timelines."],
  sla: ["Service Level Agreement", "ZettaKeep targets high control-plane availability and monitored backup infrastructure. Credits and remedies for qualifying downtime are described here."],
  subprocessors: ["Subprocessor List", "Current subprocessors include our cloud compute provider, object storage provider (e.g. Backblaze B2), payment processor (Stripe), and email provider."],
};

export default function Legal() {
  const { doc } = useParams();
  const d = docs[doc] || docs.terms;
  return (
    <div className="mx-auto max-w-3xl px-4 py-20 sm:px-6 lg:px-8">
      <Eyebrow>Legal</Eyebrow>
      <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-50">{d[0]}</h1>
      <div className="mt-6 flex items-start gap-3 rounded-xl border border-amber-500/30 bg-amber-500/5 p-4">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" />
        <p className="text-sm text-amber-200/90">This is a starter template and <b>requires attorney review before production use</b>. It is not legal advice.</p>
      </div>
      <p className="mt-6 leading-relaxed text-slate-300">{d[1]}</p>
      <p className="mt-4 text-sm text-slate-500">Last updated {new Date().toLocaleDateString()}. ZettaKeep is an independent product and is not affiliated with Proxmox Server Solutions GmbH.</p>
    </div>
  );
}
